import { rootApi } from '../rootApi';

export const inventoryManagementApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getPartDefinitions: builder.query({
            query: (params) => ({
                url: 'v1/InventoryManagement/GetPartList',
                method: 'GET',
                params: {
                    partCode: params.partCode || '',
                    languageId: params.languageId || 0,
                    pageNumber: params.pageNumber || 0,
                    pageSize: params.pageSize || 0
                }
            }),
            providesTags: ['PartDefinitions']
        }),
        getPriceInformation: builder.query({
            query: (params) => ({
                url: 'v1/InventoryManagement/GetPriceList',
                method: 'GET',
                params: {
                    partCode: params.partCode || '',
                    languageId: params.languageId || 0,
                    pageNumber: params.pageNumber || 0,
                    pageSize: params.pageSize || 0
                }
            }),
            providesTags: ['PriceInformation']
        }),
        getPriceHistory: builder.query({
            query: (params) => ({
                url: 'v1/InventoryManagement/GetPriceHistory',
                method: 'GET',
                params: {
                    partCode: params.partCode || '',
                    languageId: params.languageId || 0,
                    pageNumber: params.pageNumber || 0,
                    pageSize: params.pageSize || 0
                }
            }),
            providesTags: ['PriceHistory']
        }),

        getStockInformationList: builder.query({
            query: (params) => ({
                url: 'v1/InventoryManagement/GetStockInformationList',
                method: 'GET',
                params: {
                    partCode: params.partCode || '',
                    dealerId: params.dealerId,
                    pageNumber: params.pageNumber || 0,
                    pageSize: params.pageSize || 0
                }
            }),
            providesTags: ['StockInformation']
        }),

        getStockHistoryList: builder.query({
            query: (params) => ({
                url: 'v1/InventoryManagement/GetStockHistoryList',
                method: 'GET',
                params: {
                    partCode: params.partCode || '',
                    dealerId: params.dealerId,
                    pageNumber: params.pageNumber || 0,
                    pageSize: params.pageSize || 0
                }
            }),
            providesTags: ['StockHistory']
        }),

        getStockByPartCode: builder.query({
           query: (params) => {
        const queryParams = { partCode: params.partCode || '' };
        if (params.bosBranchCode) {
            queryParams.bosBranchCode = params.bosBranchCode;
        }
        if (params.bosBranchSiteCode) {
            queryParams.bosBranchSiteCode = params.bosBranchSiteCode;
        }
        return {
            url: 'v1/InventoryManagement/GetStockByPartCode',
            method: 'GET',
            params: queryParams
        };
    },
            providesTags: ['StockByPartCode']
        })
    })
});

export const {
    useGetPartDefinitionsQuery,
    useLazyGetPartDefinitionsQuery,
    useGetPriceInformationQuery,
    useGetPriceHistoryQuery,
    useLazyGetPriceInformationQuery,
    useLazyGetPriceHistoryQuery,
    useGetStockInformationListQuery,
    useLazyGetStockInformationListQuery,
    useGetStockHistoryListQuery,
    useLazyGetStockHistoryListQuery,
    useGetStockByPartCodeQuery
} = inventoryManagementApi;

